<div class="contact-main content-web-section">
  <div class="col-lg-12 row">
    <div class="col-lg-6 map-custom">
      <div>
        <div id="map" style="height: 400px; width: 100%;"></div>
      </div>
      <div class="mapouter">
        <div class="gmap_canvas">
            <agm-map *ngIf="!subContacts || subContacts?.length ===0"   [latitude]="defaultCoordinate.latitude" [longitude]="defaultCoordinate.longitude" [zoom]="14">
              <agm-marker [latitude]="defaultCoordinate.latitude" [longitude]="defaultCoordinate.longitude"></agm-marker>
            </agm-map>
            <!---SELECTED MAP-->
            <agm-map *ngIf="subContacts &&  subContacts?.length >0"  [latitude]="getNumber(subContacts[0]?.latitude)" [longitude]="getNumber(subContacts[0]?.longitude)" [zoom]="14">
                <ng-template ngFor let-subContactData [ngForOf]="subContacts">
                  <agm-marker [latitude]="getNumber(subContactData?.latitude)" [longitude]="getNumber(subContactData?.longitude)"></agm-marker>
                </ng-template>
            </agm-map>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <h2 class="map-select-heading">
        Select state and city to find a ITI Mutual Fund office
      </h2>
      <div class="contact-align-h">
        <div class="contact-stretch-2">
          <label for="fullName" class="lbl-text">State</label><br>
          <div class="margin-top-29">
            <select [(ngModel)]="userData.state" (change)="getCity()">
              <option value="" disabled>Please Select</option>
              <option *ngFor="let item of stateList" [value]="item.stateId">{{item.stateName | titlecase}}</option>
            </select>
          </div>
        </div>
        <div class="contact-stretch">
          <label for="fullName" class="lbl-text">City</label><br>
          <div class="margin-top-29">
            <select [(ngModel)]="userData.city" (change)="getContactOffice()">
              <option value=""  disabled>Please Select</option>
              <option *ngFor="let item of cityList" [value]="item.cityId">{{item.cityName | titlecase}}</option>
            </select>
          </div>
        </div>
      </div>
<div class="margin-bottom-50"  *ngFor="let subContactData of subContacts" role="status" aria-atomic="true">
      <ng-container *ngIf="subContactData.name">
      <div class="col-12 row">
        <div class="col-1">
          <img src="assets/icons/icon_name.png">
        </div>
        <div class="col-11">
          <h3 class="contact-sub-heading">{{subContactData.name}}</h3>
          <div class="helpline-data-mail">
            {{subContactData.emailId}}
          </div>
        </div>
      </div>

      <div class="col-12 row info-manager">
        <div class="col-1">
          <img src="assets/icons/icon_address.png">
        </div>
        <div class="col-11">
          <div class="helpline-data">
            {{subContactData.address}}
          </div>
        </div>
      </div>
      <div class="col-12 row info-manager">
        <div class="col-1">
          <img src="assets/icons/icon_phone_black.png">
        </div>
        <div class="col-11">
          <div class="helpline-data">
            {{subContactData.contactNumber}}
          </div>
        </div>
      </div>
      <div class="col-12 row info-manager" *ngIf="subContactData?.companyEmailId">
        <div class="col-1">
          <img src="assets/icons/icon_email_black.png">
        </div>
        <div class="col-11">
          <div class="helpline-data-mail">
            {{subContactData?.companyEmailId}}
          </div>
        </div>
      </div>
    </ng-container>
</div>
    </div>
  </div>
  <br><br><hr><br><br>
  <div class="col-lg-12 row">
    <div class="col-lg-6 col-md-12">
      <div class="col-lg-12 col-md-12 row">
        <div class="col-lg-2 col-md-2">
          <img src="assets/icons/phone_red.png" class="contact-icon-2" alt="">
        </div>
        <div class="col-lg-10 col-md-10" >
          <h2 class="contact-sub-heading">Helpline Numbers</h2>
          <!-- <div class="helpline-data" *ngFor="let item of contactData.helpLines">
            {{item.key}} : {{item.value}}
          </div> -->
          <dl class="helpline-data-list">
  <div class="helpline-row" *ngFor="let item of contactData.helpLines">
    <dt>{{ item.key }}</dt>
    <dd>
      <a
        *ngIf="item.key.toLowerCase().includes('number')"
        [href]="'tel:' + (item.value)"
      >
        {{ item.value }}
      </a>

      <span *ngIf="!item.key.toLowerCase().includes('number')">
        {{ item.value }}
      </span>
    </dd>
  </div>
</dl>
        </div>

      </div>
      <div class="col-lg-12 row col-md-12 mail-section">
        <div class="col-lg-2 col-md-2">
          <img src="assets/icons/red_mail.png" class="contact-icon-2" alt="">
        </div>
        <div class="col-lg-10 col-md-10">
          <h2 class="contact-sub-heading">Mail us at</h2>
          <div class="helpline-data-mail" *ngFor="let item of contactData.mailUs">
            {{item.mailId}}
          </div>
          <div class="helpline-data">
            Working Hours : Monday to Saturday – 9:00 AM to 6:00 PM
          </div>
        </div>

      </div>

    </div>
    <div class="col-lg-6 col-md-12">
      <div class="col-lg-12 col-md-12 row ">
        <div class="col-lg-2 col-md-2">
          <img src="assets/icons/red_grievance.png" class="contact-icon-2" alt="">
        </div>
        <div class="col-lg-10 col-md-10">
          <h2 class="contact-sub-heading">Grievance Redressal</h2>
          <div class="helpline-data">
            <div>If your query remains unanswered even after calling or emailing us, you may contact the Investor Relation Officer of ITI Mutual Fund.</div>
          </div>
          <h2 class="contact-sub-heading grievance-address">{{contactData.grievance.name}}</h2>
          <!-- <span class="helpline-data"><span class=" highlight"> Call</span> : {{contactData.grievance.phone}} </span>

          <br>
          <span class="helpline-data-mail"> <span class=" highlight">Email </span>:
            {{contactData.grievance.email}}</span> -->
            <dl class="helpline-data-list grievance-list">

  <div class="helpline-row">
    <dt>Call</dt>
    <dd>
      <a [href]="'tel:' + contactData.grievance.phone">
        {{contactData.grievance.phone}}
      </a>
    </dd>
  </div>

  <div class="helpline-row">
    <dt>Email</dt>
    <dd>
      <a [href]="'mailto:' + contactData.grievance.email">
        {{contactData.grievance.email}}
      </a>
    </dd>
  </div>

</dl>

          <div class="request-data">
            (We request you to provide complete details of your previous correspondence, Folio No. and contact number to
            respond to you quickly)
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<!--Mobile View -->
<div class="contact-main contact-main-mobile content-mobile-section">
  <div class="col-12 p-0 m-0 row">
      <div class="col-12  p-0 m-0 row">
        <div class="col-2">
          <img src="assets/icons/phone_red.png" class="contact-icon">
        </div>
        <div class="col-10">
          <h2 class="contact-sub-heading">Helpline Numbers</h2>
          <!-- <div class="helpline-data" *ngFor="let item of contactData.helpLines">
            {{item.key}} : {{item.value}}
          </div>
        </div> -->
        <dl class="helpline-data-list">
  <div class="helpline-row" *ngFor="let item of contactData.helpLines">
    <dt>{{item.key}}</dt>
    <dd>
      <a
        *ngIf="item.key.toLowerCase().includes('number')"
        [href]="'tel:' + item.value"
      >
        {{item.value}}
      </a>

      <span *ngIf="!item.key.toLowerCase().includes('number')">
        {{item.value}}
      </span>
    </dd>
  </div>
</dl>
       

      
      <div class="col-12  p-0 m-0 row mail-section">
        <div class="col-2">
          <img src="assets/icons/red_mail.png" class="contact-icon">
        </div>
        <div class="col-10">
          <h2 class="contact-sub-heading">Mail us at</h2>
          <div class="helpline-data-mail" *ngFor="let item of contactData.mailUs">
            {{item.mailId}}
          </div>
          <div class="helpline-data">
            Working Hours : Monday to Saturday – 9:00 AM to 6:00 PM
          </div>
        </div>

      </div>

    <div class="col-12 p-0 m-0">
      <div class="col-12  p-0 m-0 row ">
        <div class="col-2">
          <img src="assets/icons/red_grievance.png" class="contact-icon">
        </div>
        <div class="col-10">
          <div class="contact-sub-heading">Grievance Redressal</div>
          <div class="helpline-data">
            <div>If your query remains unanswered even after calling or emailing us, you may contact the Investor Relation Officer of ITI Mutual Fund. <br></div>
          </div>
          <h2 class="contact-sub-heading grievance-address">{{contactData.grievance.name}}</h2>
          <!-- <span class="helpline-data"><span class=" highlight"> Call</span> : {{contactData.grievance.phone}} </span>

          <br>
          <span class="helpline-data-mail"> <span class=" highlight">Email </span>:
            {{contactData.grievance.email}}<br></span> -->
            <dl class="helpline-data-list grievance-list">

  <div class="helpline-row">
    <dt>Call</dt>
    <dd>
      <a [href]="'tel:' + contactData.grievance.phone">
        {{contactData.grievance.phone}}
      </a>
    </dd>
  </div>

  <div class="helpline-row">
    <dt>Email</dt>
    <dd>
      <a [href]="'mailto:' + contactData.grievance.email">
        {{contactData.grievance.email}}
      </a>
    </dd>
  </div>

</dl>

          <div class="request-data">
            (We request you to provide complete details of your previous correspondence, Folio No. and contact number to
            respond to you quickly)
          </div>
        </div>

      </div>
<hr>
    </div>
  </div>
  <div class="col-12 p-0 m-0 row">
    <div class="col-12 map-custom">
      <div class="mapouter">
        <div class="gmap_canvas">
            <agm-map *ngIf="!subContacts || subContacts?.length ===0"   [latitude]="defaultCoordinate.latitude" [longitude]="defaultCoordinate.longitude" [zoom]="14">
              <agm-marker [latitude]="defaultCoordinate.latitude" [longitude]="defaultCoordinate.longitude"></agm-marker>
            </agm-map>
            <!---SELECTED MAP-->
            <agm-map *ngIf="subContacts &&  subContacts?.length >0"  [latitude]="getNumber(subContacts[0]?.latitude)" [longitude]="getNumber(subContacts[0]?.longitude)" [zoom]="14">
                <ng-template ngFor let-subContactData [ngForOf]="subContacts">
                  <agm-marker [latitude]="getNumber(subContactData?.latitude)" [longitude]="getNumber(subContactData?.longitude)"></agm-marker>
                </ng-template>
            </agm-map>
        </div>
      </div>
    </div>
    <div class="col-12">
      <h2 class="map-select-heading">
        Select state and city to find a ITI Mutual Fund office
      </h2>
      <div class="col-12 row">
        <div class="col-12">
          <label for="fullName" class="lbl-text">State</label><br>
          <select [(ngModel)]="userData.state" (change)="getCity()">
            <option value="" disabled>Please Select</option>
            <option *ngFor="let item of stateList" [value]="item.stateId">{{item.stateName | titlecase}}</option>
          </select>
        </div>
        <div class="col-12">
          <label for="fullName" class="lbl-text">City</label><br>
          <select [(ngModel)]="userData.city" (change)="getContactOffice()">
            <option value=""  disabled>Please Select</option>
            <option *ngFor="let item of cityList" [value]="item.cityId">{{item.cityName | titlecase}}</option>
          </select>
        </div>
      </div>
      <div class="margin-bottom-50"  *ngFor="let subContactData of subContacts" role="status" aria-atomic="true">
      <ng-container *ngIf="subContactData.name">
      <div class="col-12 row">
        <div class="col-2">
          <img src="assets/icons/icon_name.png">
        </div>
        <div class="col-10">
          <h2 class="contact-sub-heading">{{subContactData.name}}</h2>
          <div class="helpline-data-mail">
            {{subContactData.emailId}}
          </div>
        </div>
      </div>

      <div class="col-12 row info-manager">
        <div class="col-2">
          <img src="assets/icons/icon_address.png">
        </div>
        <div class="col-10">
          <div class="helpline-data">
            {{subContactData.address}}
          </div>
        </div>
      </div>
      <div class="col-12 row info-manager">
        <div class="col-2">
          <img src="assets/icons/icon_phone_black.png">
        </div>
        <div class="col-10">
          <div class="helpline-data">
            {{subContactData.contactNumber}}
          </div>
        </div>
      </div>
      <div class="col-12 row info-manager" *ngIf="subContactData?.companyEmailId">
        <div class="col-2">
          <img src="assets/icons/icon_email_black.png">
        </div>
        <div class="col-10">
          <div class="helpline-data-mail">
            {{subContactData.companyEmailId}}
          </div>
        </div>
      </div>
    </ng-container>
      </div>
    </div>
  </div>
  <button type="button" class="floating-button content-mobile-section" (click)="investOnline()" >Invest Online</button>

</div>
